// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function dotClass(status) {
  switch (status) {
    case "Open" :
        return "bg-candypink";
    case "Parked" :
        return "bg-yellow-400";
    case "Closed" :
        return "bg-firebrick";
    case "Resolved" :
        return "bg-americangreen";
    
  }
}

function filterActiveClass(status) {
  switch (status) {
    case "Open" :
        return "bg-candypink text-white";
    case "Parked" :
        return "bg-yellow-400 text-white";
    case "Closed" :
        return "bg-firebrick text-white";
    case "Resolved" :
        return "bg-americangreen text-white";
    
  }
}

function badgeClass(status) {
  switch (status) {
    case "Open" :
        return "bg-candypink text-white border-candypink";
    case "Parked" :
        return "bg-yellow-400 text-white border-yellow-400";
    case "Closed" :
        return "bg-firebrick text-white border-firebrick";
    case "Resolved" :
        return "bg-americangreen text-white border-americangreen";
    
  }
}

var filterAllActiveClass = "bg-palatinateblue text-white";

var filterInactiveClass = "bg-gray-100 text-gray-700 hover:bg-gray-200";

exports.dotClass = dotClass;
exports.filterActiveClass = filterActiveClass;
exports.badgeClass = badgeClass;
exports.filterAllActiveClass = filterAllActiveClass;
exports.filterInactiveClass = filterInactiveClass;
/* No side effect */
